var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-popover', { attrs: { "placement": "bottom", "width": "200", "trigger": "hover", "content": _vm.content } }, [_c('div', { staticClass: "bind-project-reference", attrs: { "slot": "reference" }, slot: "reference" }, [_c('i', { staticClass: "el-icon-warning-outline" })])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };